import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {CustomerCustomersList} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";

class NewCustomerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ShowModal: false,
      name: "",
      contact: "",
      year: "",
      day: "",
      month: "",
      date_type: "BS",
      btnDisable: false,
      formError: false,
    };
  }
  refreshCustomerList() {
    ApiConnect.get(`/Members/Information/CustomerList`)
      .then((response) => {
        this.props.CustomerCustomersList(response.data.data);
      })
      .catch((error) => console.log(error));
  }
  createNewCustomer(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("name", this.state.name);
    Fdata.append("contact", this.state.contact);
    Fdata.append("year", this.state.year);
    Fdata.append("month", this.state.month);
    Fdata.append("day", this.state.day);
    Fdata.append("date_type", this.state.date_type);
    ApiConnect({
      method: "post",
      url: "/Members/Information/NewCustomer",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            ShowModal: false,
            name: "",
            contact: "",
            year: "",
            day: "",
            month: "",
            date_type: "BS",
            btnDisable: false,
            formError: false,
          });
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }
  render() {
    return (
      <React.Fragment>
        <form onSubmit={(e) => this.createNewCustomer(e)}>
          <Modal.Body>
            <p className="text-danger">{this.state.formError}</p>
            <div className="row form-group">
              <div className="col">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
              <div className="col">
                <label className="form-label">Contact</label>
                <label className="col-12">
                  <input
                    type="number"
                    name="contact"
                    className="form-control"
                    required="required"
                    onChange={(e) => this.setState({ contact: e.target.value })}
                  />
                </label>
              </div>
            </div>
            <div className="row form-group">
              <div className="col-3 row">
                <label>Date Type *</label>
                <div className="form-group col">
                  <label>AD</label>
                  <input
                    type="radio"
                    value="AD"
                    name="date_type"
                    onChange={(e) =>
                      this.setState({ date_type: e.target.value })
                    }
                  />
                </div>
                <div className="form-group col">
                  <label>BS</label>
                  <input
                    type="radio"
                    value="BS"
                    name="date_type"
                    onChange={(e) =>
                      this.setState({ date_type: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-9 row">
                <label className="form-label">Date of Birth</label>
                <div className="col-4 form-group">
                  <label>Year</label>
                  <input
                    onChange={(e) => this.setState({ year: e.target.value })}
                    type="text"
                    className="form-control"
                    name="year"
                    required="required"
                    placeholder="year"
                  />
                </div>
                <div className="col-4">
                  <label>Month</label>
                  <select
                    name="month"
                    className="form-control"
                    size={1}
                    onChange={(e) => this.setState({ month: e.target.value })}
                  >
                    {this.state.date_type === "BS" ? (
                      <React.Fragment>
                        <option value="01">Baishakh</option>
                        <option value="02">Jestha</option>
                        <option value="03">Aashadha</option>
                        <option value="04">Shrawan</option>
                        <option value="05">Bhadra</option>
                        <option value="06">Ashwin</option>
                        <option value="07">Kartik</option>
                        <option value="08">Mangsir</option>
                        <option value="09">Paush</option>
                        <option value="10">Magh</option>
                        <option value="11">Falgun</option>
                        <option value="12">Chaitra</option>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <option value="01">January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </React.Fragment>
                    )}
                  </select>
                </div>
                <div className="col-3">
                  <label>Day</label>
                  <select
                    name="day"
                    className="form-control"
                    size={1}
                    onChange={(e) => this.setState({ day: e.target.value })}
                  >
                    <option value="01">1</option>
                    <option value="02">2</option>
                    <option value="03">3</option>
                    <option value="04">4</option>
                    <option value="05">5</option>
                    <option value="06">6</option>
                    <option value="07">7</option>
                    <option value="08">8</option>
                    <option value="09">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                  </select>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="submit"
              className="btn btn-success"
              disabled={this.state.btnDisable}
            >
              Create
            </button>
          </Modal.Footer>
        </form>
      </React.Fragment>
    );
  }
}

export default connect((state) => ({}), {
  CustomerCustomersList,
})(NewCustomerModal);
